import MyProfile from "./MyProfile.vue"
import SidebarWithHeader from "@/layouts/Sidebar/SidebarWithHeader.vue"	
import {
	Route
} from "@/types"

export const route: Route[] = [
	{
		path: "/my-profile",
		name: "MyProfile",
		component: MyProfile,
		meta: { 
			layout: SidebarWithHeader,
			module: "my-profile"
		},
	},
]

